import { Accordion, LoadingSpinner, PageMainCard } from '@/components';
import { HIRE_CONDITIONS_QUERYResult } from 'sanity.types';

export type HireConditionItem =
    NonNullable<HIRE_CONDITIONS_QUERYResult>[number];

export interface MultiAccordionsProps {
    copyData: HireConditionItem[] | null;
}

const MultiAccordions = ({ copyData = [] }: MultiAccordionsProps) => {
    const safeData = copyData ?? [];

    return (
        <PageMainCard>
            {safeData.length > 0 ? (
                safeData.map((copy: HireConditionItem, idx: number) => {
                    return (
                        <Accordion
                            key={copy.label}
                            title={copy.label ?? 'Information'}
                            content={
                                copy.content ?? 'No information available.'
                            }
                            lastItem={idx === safeData.length - 1}
                        />
                    );
                })
            ) : (
                <LoadingSpinner />
            )}
        </PageMainCard>
    );
};

export default MultiAccordions;
